module.exports = __webpack_public_path__ + "img/thumb_wallpaper_5times.c6473758.jpg";